module.exports = __webpack_public_path__ + "static/media/Iphone4.png?v=3add0607";